import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import ThemeProvider from './ThemeProvider';
import { getDirection } from 'store/language/selectors';

const mapStateToProps = createSelector(
  getDirection,
  direction => ({ direction })
);

export default connect(mapStateToProps)(ThemeProvider);



// WEBPACK FOOTER //
// ./src/components/ThemeProvider/index.js